import { Component } from '@angular/core';

/**
 * Shown by the HTTP interceptor when the server can't be reached. Reloading is left to the
 * user instead of happening automatically, so an in-flight payment is never silently re-run.
 * Opened with ignoreBackdropClick/keyboard: false, so Reload is the only way out.
 */
@Component({
  selector: 'app-reload-error-modal',
  standalone: true,
  templateUrl: './reload-error-modal.component.html',
  styleUrl: './reload-error-modal.component.scss'
})
export class ReloadErrorModalComponent {
  reload() {
    window.location.reload();
  }
}
